// extracted by mini-css-extract-plugin
module.exports = {"reply":"style_reply__1alfg","row":"style_row__2lZL5","column":"style_column__2fUOQ","author":"style_author__3RrBq","text":"style_text__-M__Q","thumbnail":"style_thumbnail__2NKmm"};